import React from "react";
import { Flex, Typography } from "antd";
import FolderIcon from '../../images/projects/FolderIcon';

const { Text } = Typography;

const FolderItem = ({ id, folderName, width, onDoubleClick}) => {
  return (
    <Flex vertical justify='center' align="center" style={{width:width, textAlign:'center', cursor:'pointer'}} onClick={() => onDoubleClick(id)} >
      <FolderIcon scale={0.2} />
      <Text style={{fontSize:10}} ellipsis>{folderName}</Text>
    </Flex>
  );
};

export default FolderItem;